import { Component, OnInit } from '@angular/core';
import { HelperService } from '@services/helper.service';
import { ModalService } from '@services/modal.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UsersService } from '@services/users.service';
import { PermissionModel } from '@models/permission.model';
import { CONSTANTS, Tabs } from '@config/constants';
import { SubjectService } from '@app/services/subject.service';

@Component({
  selector: 'app-my-payments',
  templateUrl: './my-payments.component.html',
  styleUrls: ['./my-payments.component.scss'],
})
export class MyPaymentsComponent implements OnInit {
  public permissions: Array<PermissionModel>;
  invoiceHistory = false;
  billsToPay = false;
  Tabs = Tabs;
  currentTab: Tabs;

  public navItemTabs = [
    {
      href: '#bill-to-pay',
      description: 'Factura por pagar',
      icon: 'icon-tab-bill-to-pay.svg',
      idOption: Tabs.FacturaPorPagar,
    },
    {
      href: '#bill-history',
      description: 'Historial de facturas',
      icon: 'icon-tab-bill-history.svg',
      idOption: Tabs.HistorialDeFacturas,
    },
  ];

  constructor(
    public spinner: NgxSpinnerService,
    public helper: HelperService,
    public modal: ModalService,
    private usersService: UsersService,
    public subject: SubjectService
  ) { }

  setCurrentTab(item) {
    this.currentTab = item.idOption;
  }

  showTab(idOption) {
    let showItem = false;
    switch (idOption) {
      case Tabs.FacturaPorPagar:
        showItem = this.billsToPay;
        break;
      default:
        showItem = !this.billsToPay && this.invoiceHistory;
        break;
    }
    return showItem;
  }

  ngOnInit() {
    this.subject.headerCollapse(true);
    this.permissions = this.usersService.permissions;
    this.navItemTabs = this.navItemTabs
      .filter((navItemTab) => {
        const permissionStatus = this.permissions.filter(
          (permission) => permission.idOption == navItemTab.idOption
        );
        const showItem =
          permissionStatus.length > 0 &&
          permissionStatus[0].status === CONSTANTS.PERMISSIONS.ACTIVE;

        switch (navItemTab.idOption) {
          case Tabs.FacturaPorPagar:
            this.billsToPay = showItem;
            break;
          default:
            this.invoiceHistory = showItem;
            break;
        }
        return showItem;
      })
      .map((navItemTab) => {
        const permissionStatus = this.permissions.filter(
          (permission) => permission.idOption == navItemTab.idOption
        );
        if (permissionStatus.length > 0) {
          navItemTab['status'] = permissionStatus[0].status;
        }
        return navItemTab;
      });
    this.currentTab = this.navItemTabs[0]['idOption'];
  }

  ngOnDestroy() {
    this.subject.headerCollapse(false);
  }
}
